import { createSelector } from 'reselect';
import SecurityPhoneNumberSetupStepOrder from '../../constants/security/SecurityPhoneNumberSetupStepOrder';
import { UNINITIALIZED } from '../../constants/security/SecurityPhoneNumberSetupSteps';
import RequestStatusTypes from '../../constants/RequestStatusTypes';
import { getSecurityPhoneNumberVerificationRequestStatus } from '../RequestStatusSelector';
import { VERIFY_SMS } from '../../constants/security/SecurityPhoneNumberSetupSteps';
export const getSetupStep = state => {
  const {
    setupStepIndex
  } = state.securityPhoneNumberSetup;
  if (setupStepIndex === -1) {
    return UNINITIALIZED;
  }
  return SecurityPhoneNumberSetupStepOrder[state.securityPhoneNumberSetup.setupStepIndex];
};
export const getStagedSMSNumber = state => state.securityPhoneNumberSetup.stagedSMSNumber;
export const getVerificationCodeAttempt = state => state.securityPhoneNumberSetup.verificationCodeAttempt;
export const getVerificationCodeAttemptFailed = state => state.securityPhoneNumberSetup.verificationCodeFailure;
export const getRedirectUrl = state => state.securityPhoneNumberSetup.redirectUrl;
const securityPhoneNumberConfirmedRequestStatusIsPending = createSelector([getSecurityPhoneNumberVerificationRequestStatus], requestStatus => {
  return requestStatus === RequestStatusTypes.PENDING;
});
export const getShouldBlockSetupProgress = createSelector([getVerificationCodeAttempt, securityPhoneNumberConfirmedRequestStatusIsPending, getSetupStep], (verificationCodeAttempt, isPending, setupStep) => {
  if (setupStep === VERIFY_SMS) {
    return verificationCodeAttempt === '';
  }
  return isPending;
});